import { initFilterExpression } from '../../model/filterExpressionUtils';

(function () {
	'use strict';

	/**
	 * @ngdoc component
	 * @name mx.SolutionBuilderAgent:mxObjectsLink
	 * @module mx.SolutionBuilderAgent
	 * @description Displays related object
	 * @param {string} label@ - Optional. Label of the control.
	 * @param {string} entityClassName@ - SPS class where data should be loaded from.
	 * @param {value} object= - Reference to the Entity object
	 * @param {idType} enum= - Indicates whether ObjectId or ClassId used in getting data
	 */
	angular.module('mx.SolutionBuilderAgent').component('mxObjectsLink', {
		bindings: {
			label: '@',
			value: '<',
			valueLabel: '@',
			entityClassName: '@',
			hideOnEmptyValue: '@',
			columnDefinition: '@',
			displayExpression: '@',
			idType: '@',
			valueMinWidth: '@',
			labelMinWidth: '@',
			labelMaxWidth: '@',
			labelPosition: '@?',
			designerMode: '<?',
			showingItemsCount: '<?',
			mxAtId: '@',
		},
		require: {
			parentViewController: '?^^mxView',
		},
		controller: MxObjectsLinkCtrl,
		controllerAs: 'vm',
		template: [
			'$attrs',
			function (attrs) {
				var isDesignerMode = typeof attrs.designerMode !== 'undefined';
				var optmzr = isDesignerMode && ('' + attrs.designerMode).toLowerCase() !== 'false' ? '' : '::';

				var getLiteralTemplate = function (index) {
					index = index || 0;
					var value = 'vm.value[' + index + ']';
					var showComma = value + ' && vm.value[' + (index + 1) + ']';

					return (
						'<mx-object-link ' +
						'label="" ' +
						'id-type="{{::vm.idType}}" ' +
						'ng-if="' +
						value +
						'" ' +
						'value="' +
						optmzr +
						value +
						'" ' +
						'entity-class-name="{{::vm.entityClassName}}" ' +
						'display-expression="{{::vm.displayExpression}}" ' +
						(isDesignerMode ? 'designer-mode="' + attrs.designerMode + '" ' : '') +
						'></mx-object-link><span ng-if="' +
						showComma +
						'">,&nbsp;&nbsp; </span>'
					);
				};

				var labelPosition = attrs.labelPosition;
				var literalClasses = 'mx-literal layout-wrap ' + (labelPosition === 'left' || typeof labelPosition === 'undefined' ? 'layout-row' : 'layout-column');
				var valueFlexOrderClass = labelPosition === 'bottom' ? ' flex-order--1' : '';

				var showingItemsCount = attrs.showingItemsCount === '0' ? 0 : parseInt(attrs.showingItemsCount) || 3;

				var literalsTemplate = '';
				for (var idx = 0; idx < showingItemsCount; idx++) {
					literalsTemplate += getLiteralTemplate(idx);
				}
				literalsTemplate +=
					'<a ng-if="vm.value.length > ' +
					showingItemsCount +
					'" ng-click="vm.showAll()" href="#" title="{{vm.moreItemsTooltip}}">' +
					(showingItemsCount === 0 ? '{{vm.objectsAllCount}}' : '') +
					'<b>...</b></a>';

				return (
					'<div class="' +
					literalClasses +
					'" ng-if="vm.value.length || !vm.hideOnEmptyValue">' +
					'<label ng-show="vm.label" ng-style="::{ minWidth:vm.labelMinWidth,  maxWidth:vm.labelMaxWidth}" aria-hidden="{{!!vm.label}}">{{vm.label}}</label>' +
					'<div class="literal-value mx-object-links--links-spree ' +
					valueFlexOrderClass +
					'" ' +
					'ng-style="::{ minWidth:vm.valueMinWidth}">' +
					literalsTemplate +
					'</div>'
				);
			},
		],
	});

	MxObjectsLinkCtrl.$inject = ['mx.internationalization', 'mx.SolutionBuilderAgent.DialogOpenerService', '$scope', '$attrs', '$element'];

	function MxObjectsLinkCtrl(i18n, dialogOpenerService, $scope, $attrs, $element) {
		const vm = this;

		vm.$onInit = function () {
			$scope.$watch('vm.value', updateTooltip);
			initFilterExpression({
				propertyName: 'filter-expression',
				controlMxAtId: vm.mxAtId,
				$scope,
				$attrs,
				$element,
				controller: vm,
			});
		};

		vm.showAll = function () {
			dialogOpenerService
				.openObjectsListPreview(
					{
						entityClassName: vm.entityClassName,
						label: vm.valueLabel || i18n.get('solutionBuilderAgent.components.mx-objects-literal.objects'),
						columnDefinition: vm.columnDefinition,
						useObjectId: vm.idType !== 'class',
						filterExpression: vm.filterExpression,
						selectedItemIds: vm.value.map(function (obj) {
							return obj.id || obj._id || obj;
						}),
					},
					vm.parentViewController && vm.parentViewController.mxView
				)
				.catch(mx.logCatch);
		};

		function updateTooltip() {
			if (Array.isArray(vm.value) && vm.value.length > vm.showingItemsCount) {
				vm.moreItemsTooltip = i18n.getFormatted('solutionBuilderAgent.components.mx-objects-literal.showAll', vm.value.length);
				vm.objectsAllCount = vm.value.length + ' ' + i18n.get('solutionBuilderAgent.components.mx-objects-literal.objects');
			}
		}
	}
})();
